import React from 'react';
import {
  Mail,
  Phone,
  MessageCircle,
  ExternalLink,
  LucideProps,
} from 'lucide-react';
import { Github, Linkedin } from '@/shared/ui/brand-icons';

type IconComponent = React.ComponentType<LucideProps>;

export type IconType =
  'email' | 'phone' | 'linkedin' | 'github' | 'whatsapp' | 'external';

/**
 * Maps a free-text CMS `type` string onto an icon.
 *
 * Takes `string`, not {@link IconType}: the value comes from Strapi and is not
 * constrained by the schema, so unknown and misspelled values must resolve to
 * the generic external-link icon rather than crash a card.
 */
export const getIconFromType = (
  iconType: string,
  props: LucideProps = {},
): React.ReactElement => {
  const getIcon = (iconType: string): IconComponent => {
    const normalizedType = iconType.toLowerCase().trim();

    switch (normalizedType) {
      case 'email':
      case 'mail':
        return Mail;
      case 'phone':
      case 'tel':
        return Phone;
      case 'linkedin':
      case 'linkedin.com':
        return Linkedin;
      case 'github':
      case 'github.com':
        return Github;
      case 'whatsapp':
      case 'wa':
        return MessageCircle;
      case 'external':
      case 'link':
      default:
        return ExternalLink;
    }
  };

  const IconComponent = getIcon(iconType);
  return React.createElement(IconComponent, props);
};
